export const FORM_FETCH_LOGIN_REQUEST = 'FETCH_USER_LOGIN_REQUEST';
export const FORM_FETCH_LOGIN_SUCCESS = 'FETCH_USER_LOGIN_SUCCESS';
export const FORM_FETCH_LOGIN_FAILURE = 'FETCH_USER_LOGIN_FAILURE'

export const FORM_FETCH_SIGNUP_REQUEST = 'FETCH_USER_SIGNUP_REQUEST';
export const FORM_FETCH_SIGNUP_SUCCESS = 'FETCH_USER_SIGNUP_SUCCESS';
export const FORM_FETCH_SIGNUP_FAILURE = 'FETCH_USER_SIGNUP_FAILURE'